export const opportunitiesInitialState = {
    countries: null,
    isLoading: true,
}